import { allValues, Rights } from '../rights';

export const SUPERVISION_MANAGEMENT_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.WRITE.key,
  ...allValues(Rights.RESIDENTS.GENERAL),
  Rights.RESIDENTS.CONTRACT.READ.key,
  ...allValues(Rights.RESIDENTS.CONTACTS),
  ...allValues(Rights.RESIDENTS.CONSULTATION),
  ...allValues(Rights.RESIDENTS.UTILS),
  ...allValues(Rights.RESIDENTS.PASTORAL_CARE),
  ...allValues(Rights.RESIDENTS.DOCUMENT_MANAGEMENT),
  Rights.RESIDENTS.FILES.READ.key,
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.GENERAL.READ.key,
  Rights.EMPLOYEES.CONTRACT.READ.key,
  Rights.EMPLOYEES.CHECKLIST.READ.key,
  Rights.EMPLOYEES.FILES.READ.key,
  Rights.EMPLOYEES.WORK.READ.key,
  Rights.EMPLOYEES.CALENDAR.READ.key,
  Rights.EMPLOYEES.VACATION.READ.key,
  Rights.EMPLOYEES.MISC.READ.key,
  Rights.EMPLOYEES.TRAINING.READ.key,
  Rights.BASE_DATA.DOCTORS.READ.key,
  ...allValues(Rights.BASE_DATA.SUPERVISOR),
  Rights.CARE.READ.key,
  Rights.CARE.WRITE.key,
  ...allValues(Rights.CARE.TASKS),
  ...allValues(Rights.CARE.EXECUTION),
  Rights.CARE.ASSESSMENT.READ.key,
  Rights.CARE.CONSULTATION_FORM.READ.key,
  Rights.CARE.MOVEMENT_STATUS.READ.key,
  ...allValues(Rights.CARE.MEDICATION_ORDER),
  ...allValues(Rights.CARE.BIOGRAPHY),
  Rights.CARE.DATA_COLLECTION.READ.key,
  Rights.CARE.DECUBITUS_RISK.READ.key,
  ...allValues(Rights.CARE.NUTRITION_PROTOCOL),
  ...allValues(Rights.CARE.CASE_DISCUSSION),
  Rights.CARE.INDICATORS.READ.key,
  Rights.CARE.MEDICATION.READ.key,
  ...allValues(Rights.CARE.NURSING_REPORT),
  Rights.CARE.REPORT.READ.key,
  Rights.CARE.CARE_PLAN_SUPERVISOR.key,
  Rights.CARE.CARE_PLAN.READ.key,
  Rights.CARE.NURSE_VISIT.READ.key,
  Rights.CARE.CARE_ROUNDS.READ.key,
  Rights.CARE.PAIN_PROTOCOL.READ.key,
  ...allValues(Rights.CARE.SOCIAL_CARE),
  Rights.CARE.SOCIAL_CARE_GROUP.key,
  ...allValues(Rights.CARE.FALL_PROTOCOL),
  Rights.CARE.FALL_RISK.READ.key,
  Rights.CARE.VITAL_INFORMATIONS.READ.key,
  Rights.CARE.DOCTORS_DIAGNOSIS.READ.key,
  Rights.CARE.VISIT_SHEET.READ.key,
  Rights.CARE.WOUND_DOCUMENTATION.READ.key,
  Rights.GENERAL.CASH_AMOUNT.READ.key,
  Rights.GENERAL.CASH_AMOUNT.WRITE.key,
  ...allValues(Rights.GENERAL.CALENDAR),
  ...allValues(Rights.GENERAL.CONTACTS),
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.MANAGE.key,
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
  ...allValues(Rights.CARE.GENERAL_ORDER),
]);
